export const 직위옵션 = ["현장소장", "안전전담자", "관리감독자", "작업자", "화재감시자", "신호수", "감시인", "측정자"]
